import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import axios from "axios";
import { genURL, genURLTEST } from "../../_getjson";

import moment from "moment/moment";
import "moment/locale/th";
import { Button, Tab, Tabs, Typography } from "@mui/material";
import CustomSiteCodeInput from "../../Components/CustomSiteCode/customsitecodeinput";
import CustomARInput from "../../Components/CustomARInput/CustomARInput";
import ConditionARSelect from "../../Components/ConditionSearch/Components/ConditionSelectAR";
import ConditionSelectProduct from "../../Components/ConditionSearch/Components/ConditionSelectProduct";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../assets/jss/psstyle/psacount";
import CustomInput from "../../Components/CustomInput/CustomInput";
import CustominputRang from "../../Components/CustomInput/CustominputRang";
import CustomDateRangePicker from "../../Components/CustomDatepicker/CustomDateRangePicker";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import { Details } from "@mui/icons-material";

const from = "saleOrder";
const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "docDate",
    headerName: "วันที่เอกสาร",
    width: 150,
    editable: false,
  },
  {
    field: "docNo",
    headerName: "เลขที่เอกสาร",
    width: 200,
    editable: false,
  },

  {
    field: "arCode",
    headerName: "รหัสลูกค้า",
    width: 110,
    editable: false,
  },
  {
    field: "arName",
    headerName: "ชื่อลูกค้า",
    width: 200,
    editable: false,
  },
  {
    field: "remark",
    headerName: "หมายเหตุ",
    width: 200,
    editable: false,
    // flex: 1
  },
  {
    field: "debtAmount",
    headerName: "รวมเงินทั้งสิ้น",
    width: 200,
    editable: false,
  },
  {
    field: "c",
    headerName: "C",
    width: 100,
    editable: false,
  },
  {
    field: "refDocNo",
    headerName: "บิลขาย",
    width: 100,
    editable: false,
  },
  {
    field: "saleName",
    headerName: "พนักงานขาย",
    width: 100,
    editable: false,
  },
  {
    field: "department",
    headerName: "แผนก",
    width: 100,
    editable: false,
  },
  {
    field: "project",
    headerName: "โครงการ",
    width: 100,
    editable: false,
  },
  {
    field: "createUser",
    headerName: "CREATEUSER",
    width: 100,
    editable: false,
  },
  {
    field: "upDateUser",
    headerName: "UPDATEUSER",
    width: 100,
    editable: false,
  },
  {
    field: "upDate",
    headerName: "UPDATE",
    width: 100,
    editable: false,
  },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export default function Rechecked(props) {
  const [state, setState] = React.useState({
    tabValue: 0,
    rows: [],
    openbackdrop: false,
    dateStart: "",
    dateEnd: "",
    docNoStart: "",
    docNoEnd: "",
    siteCode: "",
    arCode: "",
    ARSelect: [],
    ProductSelect: [],
    rowList: 100,
    top: "100",
    detail: "ไม่พบข้อมูล",
  });

  const loadData = async (val, ConditionData) => {
    setState({
      ...state,
      openbackdrop: true,
    });
    // let url = ''
    // if (val === 'all') {
    // url = `CSPURCHASE/Search?top=100&startdate=${datestartdata != null ? datestartdata : ""}&enddate=${dateenddata != null ? dateenddata : ""}&startdocno=${docnostartdata != null ? docnostartdata : ""}&enddocno=${docnoenddata != null ? docnoenddata : ""}`
    // } else {
    let url = `CSQUOT/SearchData?ConditionData=${ConditionData}`;
    // }

    let rs = await axios.get(genURL(url), { timeout: 36000 }).catch((error) => {
      setState({
        ...state,
        openbackdrop: false,
        detail: "error" + error,
      });
      console.log(error);
    });

    // console.log("vcsquot", genURL(url))
    // let rs = await axios.get(genURLTEST(`/SearchData?ConditionData=${ConditionData}`), { timeout: 12000 }).catch((error) => {
    //     setState({
    //         ...state,
    //         openbackdrop: false,
    //         detail: "error"
    //     })
    //     console.log("error", error);
    // })

    console.log("rs", rs);
    let element = [];
    if (typeof rs !== "undefined" && rs.data.length > 0) {
      console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        await element.push({
          id: Number(index) + 1,
          docDate: moment(rs.data[index].DOCDATE).format("L"),
          docNo: rs.data[index].DOCNO,
          arCode: rs.data[index].ARCODE,
          arName: rs.data[index].ARNAME,
          remark: rs.data[index].REMARK,
          debtAmount: rs.data[index].DEBTAMOUNT,
          refDocNo: rs.data[index].REFDOCNO,
          saleName: rs.data[index].SALENAME,
          createUser: rs.data[index].SALECODE,
          project: rs.data[index].PROJECTNAME,
          createUser: rs.data[index].OWNERCODE,
          upDateUser: rs.data[index].UPDATEUSER,
          upDate: rs.data[index].SYSUPDATE,
          fontColor: rs.data[index].FONTCOLOR,
          department: rs.data[index].DEPARTMENT,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
    }
    await setState({
      ...state,
      rows: element,
      openbackdrop: false,
    });
  };
  const resData = (e) => {
    // console.log("resData resData", e)
  };
  const removeresData = (e) => {
    //  console.log("resData removeresData", e)
  };
  const selcetRow = async (e) => {
    await props.Dataselect(e);
    // console.log("selcetRow", e)
  };
  const SearchData = async () => {
    console.log(
      "SearchData",
      state.dateStart,
      state.dateEnd,
      state.docNoStart,
      state.docNoEnd,
      state.arCode,
      state.siteCode,
      state.ARSelect,
      state.ProductSelect
    );

    let ConditionData = await JSON.stringify([
      {
        StartDate:
          state.dateStart !== ""
            ? format(new Date(state.dateStart), "yyyy-MM-dd", { locale: th })
            : "",
        EndDate:
          state.dateEnd !== ""
            ? format(new Date(state.dateEnd), "yyyy-MM-dd", { locale: th })
            : "",
        StartDocNo: state.docNoStart,
        EndDocNo: state.docNoEnd,
        ArCode: state.arCode,
        SiteCode: state.siteCode,
        ArMainGroup: state.ARSelect.arMainGroup, //e[1].arMainGroup,
        ArtableData: JSON.stringify(state.ARSelect.arTableData),
        ProductBrand: state.ProductSelect.productBrand,
        ProductColor: state.ProductSelect.productColor,
        ProductMainGroup: state.ProductSelect.productMainGroup,
        ProductModel: state.ProductSelect.productModel,
        ProductStatus: state.ProductSelect.productStatus,
        ProductType: state.ProductSelect.productType,
        ProductTableData: JSON.stringify(state.ProductSelect.productTableData),
        Top: state.rowList,
      },
    ]);
    await loadData("all", ConditionData);
  };

  // end  รับค่าวันที่
  const resultCondition = (provenance, value) => {
    console.log("resultCondition", provenance, "value", value);
    if (provenance === "ARSelect") {
      setState({
        ...state,
        ARSelect: value,
      });
    } else if (provenance === "ProductSelect") {
      console.log("resultCondition", provenance, value);
      setState({
        ...state,
        ProductSelect: value,
      });
    }
  };
  const setResData = async (e) => {
    await setState({
      ...state,
      rowList: e,
    });
  };

  const resInput = async (source, e) => {
    console.log("xxxxxxxxxxxxxxxxxx", e);
    if (source === "DocDate") {
      await setState({
        ...state,
        dateStart: e.dateStart,
        dateEnd: e.dateEnd,
      });
    } else if (source === "DocNo") {
      await setState({
        ...state,
        docNoStart: e.docNoStart,
        docNoEnd: e.docNoEnd,
      });
    } else if (source === "siteCode") {
      await setState({
        ...state,
        siteCode: e,
      });
    } else if (source === "arCode") {
      await setState({
        ...state,
        arCode: e,
      });
    }
  };

  const tabHandleChange = (event, newValue) => {
    setState({
      ...state,
      tabValue: newValue,
    });
    //  setTabValue(newValue);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={1}>
        <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
          <Button
            variant="outlined"
            startIcon={<SearchRoundedIcon />}
            sx={{
              pt: -5,
              height: "32px",
              mt: 1.4,
              borderColor: grayColor[11],
              color: blackColor[0],
              fontFamily: defaultFont,
            }}
            onClick={() => SearchData()}
            size="small"
          >
            ค้นหา
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <CustomInput
            inputType={"number"}
            id={"rowSelect"}
            label={`จำนวนรายการ`}
            placeholder={
              "ถ้าต้องการรายการทั้งหมดตามเงื่อนไขให้กรอก -1 ค่าเริ่มต้นเป็น 100"
            }
            resData={(e) => setResData(e)}
          />
        </Grid>
      </Grid>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={state.tabValue}
          onChange={tabHandleChange}
          aria-label="basic tabs example"
        >
          <Tab label="เงื่อนไข" {...a11yProps(0)} />
          <Tab label={"ลูกหนี้"} {...a11yProps(1)} />
          <Tab label="สินค้า" {...a11yProps(2)} />
        </Tabs>{" "}
        {/*    */}
        <TabPanel value={state.tabValue} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
              <CustomDateRangePicker
                label={"วันที่"}
                resData={(e) => resInput("DocDate", e)}
                defaultValue={state}
              />
            </Grid>
            <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
              <CustominputRang
                label={"เลขที่เอกสาร"}
                resData={(e) => resInput("DocNo", e)}
                inputType={"text"}
                keyDown={(e) => keyDown(e)}
                defaultValue={state}
              />
            </Grid>
            <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
              <CustomSiteCodeInput
                label={"สาขา"}
                resData={(e) => resInput("siteCode", e)}
                inputType={"text"}
                keyDown={(e) => keyDown(e)}
                defaultValue={state.siteCode}
              />
            </Grid>
            <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
              <CustomARInput
                label={"ลูกค้า"}
                resData={(e) => resInput("arCode", e)}
                inputType={"text"}
                keyDown={(e) => keyDown(e)}
                defaultValue={state.arCode}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={state.tabValue} index={1}>
          <ConditionARSelect
            result={(e) => resultCondition("ARSelect", e)}
            defaultValue={state.ARSelect}
          />
        </TabPanel>
        <TabPanel value={state.tabValue} index={2}>
          <ConditionSelectProduct
            result={(e) => resultCondition("ProductSelect", e)}
            defaultValue={state.ProductSelect}
          />
        </TabPanel>
      </Box>
      <Box>
        {state.rows.length > 0 ? (
          <CustomDataGrid
            datacolumns={columns}
            datarows={state.rows}
            rowHeight={38}
            Dataintable={(e) => resData(e)}
            Dataintableremove={(e) => removeresData(e)}
            startRow={1}
            option={[{ add: false, del: false, select: true }]}
            // checkboxSelection
            onRowClick={(e) => selcetRow([e.row])}
            // Dataselect={e => selcetRow(e)}

            RowsModelChange={(_) => console.log("RowsModelChange")}
            from={from}
          />
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} textAlign={"center"}>
              {state.detail}
            </Grid>
          </Grid>
        )}
      </Box>
      <CustomBackdrop open={state.openbackdrop} />
    </Box>
  );
}
